import React from 'react'
import styled from 'styled-components'

const Header = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  background-color: 'white';
  padding: 1rem;
  align-items: center;
  border: 1px solid ${(props) => props.theme.palette.grey.grey300};
  border-radius: 0.625rem;
  margin-bottom: 1rem;
  gap: 1rem;
`

interface TableManipulationTopContainerProps {
  children: React.ReactNode
}

const TableManipulationTopContainer = React.forwardRef<
  HTMLDivElement,
  TableManipulationTopContainerProps
>(
  (
    props: TableManipulationTopContainerProps,
    ref: React.Ref<HTMLDivElement>
  ) => {
    return (
      <Header ref={ref} {...props}>
        {props.children}
      </Header>
    )
  }
)

// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  TableManipulationTopContainer.displayName = 'TableManipulationTopContainer'
}

export default React.memo(TableManipulationTopContainer)
